import React from "react";

const shimmer =
  "animate-pulse bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%]";

const ProjectListShimmer = () => {
  return (
    <div className="h-[72vh] w-full flex ">
      {/* Sidebars */}

      <div className="w-[100%] h-[72vh] flex flex-col gap-3 items-center justify-start">
        {/* Main 500x500 shimmer box */}
        {/* Absolute shimmer bar at bottom */}
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
      </div>
    </div>
  );
};

export default ProjectListShimmer;
